if (typeof window.initCustomAccordion !== 'function') {
  window.initCustomAccordion = function (itemSelector, triggerSelector, contentSelector, root) {
    var scope = root || document;
    var items = scope.querySelectorAll(itemSelector);

    // Collapsed panels are only squashed to zero height, so links inside them
    // would stay in the tab order while invisible. `inert` takes them out of
    // the tab order and away from screen readers until the panel opens.
    function setOpen(item, open) {
      var trigger = item.querySelector(triggerSelector);
      var content = item.querySelector(contentSelector);
      item.classList.toggle('is-open', open);
      if (content) {
        content.style.maxHeight = open ? content.scrollHeight + 'px' : '0';
        content.inert = !open;
      }
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item, index) {
      var trigger = item.querySelector(triggerSelector);
      var content = item.querySelector(contentSelector);
      if (!trigger || !content) return;

      if (!content.id) content.id = 'Accordion-' + Date.now().toString(36) + '-' + index;
      trigger.setAttribute('aria-controls', content.id);
      content.inert = !item.classList.contains('is-open');

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (otherItem) {
          if (otherItem !== item) setOpen(otherItem, false);
        });
        setOpen(item, !isOpen);
      });
    });
  };
}

// <custom-accordion data-item="…" data-trigger="…" data-content="…"> starts the
// accordion inside itself whenever it's added to the page. That includes the
// theme editor re-rendering its section, which a DOMContentLoaded listener
// misses, and it never binds another section's items.
if (!customElements.get('custom-accordion')) {
  customElements.define(
    'custom-accordion',
    class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        window.initCustomAccordion(this.dataset.item, this.dataset.trigger, this.dataset.content, this);
      }
    }
  );
}
